<template>
  <div>
    <b-button v-b-modal.modal-facility-booker variant="outline-success"
      >Створити запис</b-button
    >
    <b-modal
      title="Створення запису"
      id="modal-facility-booker"
      @hidden="resetModal"
      @ok="createVisit"
      @show="resetModal"
      centered
    >
      <form ref="form" @submit.stop.prevent="createVisit">
        <b-form-group
          class="mt-2"
          label="Клуб"
          invalid-feedback="Оберіть клуб!"
        >
          <b-form-select
            v-model="visit.club_id"
            class="form-control"
            :class="{
              'is-invalid': $v.visit.club_id.$error && $v.visit.club_id.$dirty,
            }"
            :options="clubOptions"
          >
          </b-form-select>
        </b-form-group>
        <b-form-group
          class="mt-2"
          label="Приміщення"
          invalid-feedback="Введіть назву приміщення!"
        >
          <b-form-input
            v-model="visit.facility"
            :class="{
              'is-invalid':
                $v.visit.facility.$error && $v.visit.facility.$dirty,
            }"
            type="text"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          class="mt-2"
          label="Спеціаліст"
          invalid-feedback="Введите им'я спеціалісту!"
        >
          <b-form-input
            v-model="visit.specialist"
            :class="{
              'is-invalid':
                $v.visit.specialist.$error && $v.visit.specialist.$dirty,
            }"
            type="text"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          class="mt-2"
          label="Клієнт"
          invalid-feedback="Введіть ім'я клиєнту!"
        >
          <b-form-input
            v-model="visit.client"
            :class="{
              'is-invalid': $v.visit.client.$error && $v.visit.client.$dirty,
            }"
            type="text"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          class="mt-2"
          label="Номер телефону"
          invalid-feedback="Введіть номер телефону!"
        >
          <b-form-input
            v-model="visit.phonenumber"
            :class="{
              'is-invalid':
                $v.visit.phonenumber.$error && $v.visit.phonenumber.$dirty,
            }"
            type="number"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          class="mt-2"
          label="Дата"
          invalid-feedback="Оберіть дату!"
        >
          <b-form-input
            v-model="visit.date"
            :class="{
              'is-invalid': $v.visit.date.$error && $v.visit.date.$dirty,
            }"
            type="date"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group class="mt-2" label="Час" invalid-feedback="Оберіть час!">
          <b-form-input
            v-model="visit.time"
            :class="{
              'is-invalid': $v.visit.time.$error && $v.visit.time.$dirty,
            }"
            type="time"
          >
          </b-form-input>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";

export default {
  name: "FacilityBooker",
  data: function () {
    return {
      clubOptions: [
        { value: 1, text: "Василенко, 9" },
        { value: 2, text: "Острозького, 55" },
      ],
      visit: {
        club_id: null,
        facility: null,
        specialist: null,
        client: null,
        phonenumber: null,
        date: null,
        time: null,
      },
    };
  },
  validations: {
    visit: {
      club_id: {
        required,
      },
      facility: {
        required,
      },
      specialist: {
        required,
      },
      client: {
        required,
      },
      phonenumber: {
        required,
      },
      date: {
        required,
      },
      time: {
        required,
      },
    },
  },
  methods: {
    ...mapActions(["logOutUser"]),
    async createVisit(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      await this.$api.facilities.createRecord(this.visit).then(() => {
        this.$emit("success");
      });
      this.$nextTick(() => {
        this.$bvModal.hide("modal-facility-booker");
      });
    },
    resetModal() {
      for (let field in this.visit) {
        this.visit[field] = null;
      }
      this.$v.visit.$reset();
    },
  },
};
</script>

<style scoped></style>
